import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import './SponsorsSection.css';

function SponsorsSection() {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        console.log('📡 Chargement des sponsors...');
        const { data, error: err } = await supabase
          .from('sponsors')
          .select('id, title, logo, website')
          .order('created_at', { ascending: false });
        
        console.log('✅ Réponse Supabase:', { data, err });
        
        if (err) {
          console.error('❌ Erreur Supabase:', err);
          throw err;
        }
        if (!active) return;
        
        console.log('📊 Sponsors chargés:', data?.length || 0);
        setSponsors((data || []).filter((s) => s.logo));
        setError(null);
      } catch (err) {
        console.error('❌ Erreur chargement sponsors:', err);
        if (active) setError(err.message);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const hasSponsors = sponsors.length > 0;

  const renderSponsor = (s) => {
    const inner = (
      <div className="bl-sponsor" title={s.title || 'Sponsor'}>
        <img src={s.logo} alt={s.title || 'Sponsor'} loading="lazy" />
      </div>
    );
    return s.website ? (
      <a
        key={s.id}
        href={s.website}
        target="_blank"
        rel="noopener noreferrer"
        className="bl-sponsor-link"
      >
        {inner}
      </a>
    ) : (
      <div key={s.id} className="bl-sponsor-link">
        {inner}
      </div>
    );
  };

  return (
    <section className="sponsors-section sponsors-section-bg" id="sponsors">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nos Sponsors</h2>
          <p className="section-subtitle">Rejoignez les entreprises qui nous font confiance</p>
        </div>

        {/* Grille des sponsors */}
        {hasSponsors ? (
          <div className="bl-sponsors-grid">
            {sponsors.map(renderSponsor)}
          </div>
        ) : (
          <div className="sponsors-placeholder">
            {loading ? (
              <div className="sponsors-loading">
                <div className="loading-spinner"></div>
                <p>Chargement des sponsors...</p>
              </div>
            ) : (
              <div className="sponsors-empty">
                <p>Aucun sponsor pour le moment. Soyez le premier à nous rejoindre !</p>
              </div>
            )}
          </div>
        )}

        {/* Message d'erreur */}
        {error && (
          <div className="sponsors-error">
            <p>Erreur lors du chargement des sponsors. Veuillez réessayer.</p>
          </div>
        )}

      </div>
    </section>
  );
}

export default SponsorsSection;
